import {
  Directive,
  HostListener,
  ElementRef,
  OnInit,
  Input,
  AfterViewInit,
  Renderer2,
  ChangeDetectorRef,
  Attribute
} from '@angular/core';
import { TextFormElement } from '../text/text-form-element';
import { PhoneFormatService } from 'libs/framwork/services/phone-format.service';
@Directive({
  selector: '[HccPhone]'
})
export class PhoneDirective extends TextFormElement
  implements OnInit, AfterViewInit {
  private elBase: any;
  constructor(
    private customPhonePipe: PhoneFormatService,
    protected renderer: Renderer2,
    protected el: ElementRef,
    protected csRef: ChangeDetectorRef,
    @Attribute('updateEvent') protected updateEvent
  ) {
    super(renderer, el, csRef, updateEvent);
  }
  ngOnInit() {
    this.elBase = this.el.nativeElement;
  }

  ngAfterViewInit(): void {
    this.updateValue();
  }

  @HostListener('focus', ['$event.target.value', '$event'])
  onFocus(value, event) {
    this.elBase.value = this.elBase.value.replace(/[,(,),\s,-]/g, '');
  }

  @HostListener('blur', ['$event.target.value'])
  onBlur(value) {
    if (isNaN(parseFloat(value))) {
      this.elBase.value = '';
      return;
    }
    //  this.elBase.value = this.customCurrencyPipe.toCurrency(value);
    this.updateValue();
  }

  updateValue() {
    this.elBase.value = this.customPhonePipe.toPhoneFormat(this.elBase.value);
  }
}
